module.exports = __webpack_public_path__ + "img/visitor-img3.7a9078c7.png";